import { render } from "./MyCalculator.vue?vue&type=template&id=e4253d7e&scoped=true"
import script from "./MyCalculator.vue?vue&type=script&lang=js"
export * from "./MyCalculator.vue?vue&type=script&lang=js"

import "./MyCalculator.vue?vue&type=style&index=0&id=e4253d7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4253d7e"]])

export default __exports__